import "./sbemptystate.scss";
import React from "react";
import Button from "../../Buttons/Button";
import Typography from "../../Typography";

const SbEmptyState = ({
  img,
  imgWidth,
  imgHeight,
  title,
  subtitle,
  isBtn,
  isPlainBtn,
  btnLeftIcon,
  btnRightIcon,
  btnText,
  btnHandleClick,
}) => {
  return (
    <div className="sb-empty-state-card">
      {typeof img === "string" ? (
        <img
          src={img}
          width={imgWidth}
          height={imgHeight}
          alt="empty-state-card"
          className={imgWidth ? "" : "full-width"}
        />
      ) : img ? (
        img
      ) : (
        <></>
      )}
      <Typography size="heading-lg" weight="medium">
        {title}
      </Typography>
      {subtitle?.length > 0 && (
        <Typography customClass="subtitle">{subtitle}</Typography>
      )}
      {isBtn && (
        <Button
          size="sm"
          text={btnText}
          isPlain={isPlainBtn}
          leftIcon={btnLeftIcon}
          rightIcon={btnRightIcon}
          handleClick={btnHandleClick}
        />
      )}
    </div>
  );
};

export default SbEmptyState;
